import { Role } from '../enums/role.enum';
import { CurrentUser } from './current-user';

export class CompanyUser implements CurrentUser {
  email: string;

  fullName: string;

  role: Role;

  defaultUrl: string;

  companyId: string;

  constructor(user: any) {
    this.companyId = user.companyId;
    this.email = user.email;
    this.fullName = user.representativeName;
    this.role = user.role;
    if (this.role === Role.COMPANY_ADMIN) {
      this.defaultUrl = '/company-products';
    } else if (this.role === Role.SALES_REP || this.role === Role.MSL || Role.PATIENT_ASSISTANCE) {
      this.defaultUrl = '/chat';
    } else if (this.role === Role.ADMIN) {
      this.defaultUrl = '/companies';
    }
  }
}
